import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { AISearchModel, AISearchModelImpl } from './model/ai-search.model';
import { AISearchService, AISearchServiceImpl } from './service/ai-search.service';
import { AISearchStrategyService, AISearchStrategyServiceImpl } from './service/ai-search-strategy.service';
import { TechStrategyModel, TechStrategyModelImpl } from './model/tech-strategy.model';
import { AISearchDescriptionModel, AISearchDescriptionModelImpl } from './model/ai-search-description.model';
import { AISearchDescriptionService, AISearchDescriptionServiceImpl } from './service/ai-search-description.service';
import { AISearchSummaryModel, AISearchSummaryModelImpl } from './model/ai-search-summary.model';
import { AISearchSummaryService, AISearchSummaryServiceImpl } from './service/ai-search-summary.service';
import { AISearchElementsModel, AISearchElementsModelImpl } from './model/ai-search-elements.model';
import { AISearchElementsService, AISearchElementsServiceImpl } from './service/ai-search-elements.service';
import { AISearchRepository } from './service/ai-search.repository.interface';
import { AISearchRepositoryImpl } from './repository/ai-search.repository';
import { CheckSensitiveWordDTO, CheckSensitiveWordDTOImpl } from './repository/data-transfer/check-sensitive-word.dto';
import { QueryTransformService, QueryTransformServiceImpl } from './service/query-transform.service';
import { GetQueryCountDTO, GetQueryCountDTOImpl } from './repository/data-transfer/get-query-count.dto';
import { SetTechQueryDTO, SetTechQueryDTOImpl } from './repository/data-transfer/set-tech-query.dto';
import { TransferQueryDTO, TransferQueryDTOImpl } from './repository/data-transfer/transfer-query.dto';
import { GetRelatedIpcDTO, GetRelatedIpcDTOImpl } from './repository/data-transfer/get-related-ipc.dto';

import { GetTechAreaDTO, GetTechAreaDTOImpl } from './repository/data-transfer/get-tech-area.dto';
import { GetTechKeywordDTO, GetTechKeywordDTOImpl } from './repository/data-transfer/get-tech-keyword.dto';
import { GetTechSemanticDTO, GetTechSemanticDTOImpl } from './repository/data-transfer/get-tech-semantic.dto';

export const AISearchModule = (bind: interfaces.Bind) => {
    bind(AISearchModel).to(AISearchModelImpl);
    bind(AISearchService).to(AISearchServiceImpl);
    bind(AISearchDescriptionModel).to(AISearchDescriptionModelImpl);
    bind(AISearchDescriptionService).to(AISearchDescriptionServiceImpl);
    bind(AISearchSummaryModel).to(AISearchSummaryModelImpl);
    bind(AISearchSummaryService).to(AISearchSummaryServiceImpl);
    bind(AISearchElementsModel).to(AISearchElementsModelImpl);
    bind(AISearchElementsService).to(AISearchElementsServiceImpl);
    bind(AISearchRepository).to(AISearchRepositoryImpl);
    bind(CheckSensitiveWordDTO).to(CheckSensitiveWordDTOImpl);
    bind(QueryTransformService).to(QueryTransformServiceImpl);
    bind(GetQueryCountDTO).to(GetQueryCountDTOImpl);
    bind(SetTechQueryDTO).to(SetTechQueryDTOImpl);
    bind(TransferQueryDTO).to(TransferQueryDTOImpl);
    bind(AISearchStrategyService).to(AISearchStrategyServiceImpl);
    bind(TechStrategyModel).to(TechStrategyModelImpl);

    bind(GetTechAreaDTO).to(GetTechAreaDTOImpl);
    bind(GetTechKeywordDTO).to(GetTechKeywordDTOImpl);
    bind(GetTechSemanticDTO).to(GetTechSemanticDTOImpl);
    bind(GetRelatedIpcDTO).to(GetRelatedIpcDTOImpl);
};
